import * as React from 'react';
import { Player } from 'video-react';
import Background from '../../assets/img/bg.png';
import Logo from '../../assets/img/logo_mindwell.svg';
import Play from '../../assets/img/icon_play.svg';
import Pause from '../../assets/img/icon_pause.svg';
import SVG from 'react-inlinesvg';
import styles from './styles';
import injectSheet from 'react-jss';

class Meditation extends React.Component{

  constructor(props) {
    super(props);
    this.player = React.createRef();
    this.circle = React.createRef();
    this.state = {
      playerState: {},
      coords: {},
      isFirstMove: true,
    };
  }

  componentDidMount() {
    this.player.subscribeToStateChange(this.setPlayerState);
  }

  setPlayerState = state => {
    this.setState({
      playerState: state
    })
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.video !== this.props.video) {
      return this.props.video ? this.player.current.play() : this.player.current.pause();
    }
    return null;
  }

  play = () => this.player.play();

  pause = () => this.player.pause();

  loadPercentage = () => {
    if (!this.state.playerState.buffered || !this.state.playerState.buffered.length) {
      return 0;
    }
    const bufferedEnd = this.state.playerState.buffered.end(this.state.playerState.buffered.length - 1);

    if (bufferedEnd > this.state.playerState.duration) {
      return this.state.playerState.duration;
    }

    return bufferedEnd / this.state.playerState.duration || 0;
  };

  playedPercentage = () => {
    if (!this.state.playerState.duration || !this.state.playerState.currentTime) {
      return 0;
    }

    return this.state.playerState.currentTime / this.state.playerState.duration || 0;
  };

  coordinateX = () => {
    let played = this.playedPercentage();
    if (played <= 0.25) {
      return 92 + 81 * Math.cos((Math.PI / 2) * (played / 0.25));
    }
    if (played > 0.25 && played <= 0.5) {
      played -= 0.25;
      return 11 + 81 * (1 - Math.sin((Math.PI / 2) * (played / 0.25)));
    }
    if (played > 0.5 && played <= 0.75) {
      played -= 0.5;
      return 11 + 81 * (1 - Math.sin((Math.PI / 2) * ((0.25 - played) / 0.25)));
    }
    if (played > 0.75 && played <= 1) {
      played -= 0.75;
      return 92 + 81 * Math.cos((Math.PI / 2) * ((0.25 - played) / 0.25));
    }
    return 0;
  };

  coordinateY = () => {
    let played = this.playedPercentage();
    if (played <= 0.25) {
      return 92 + 81 * Math.sin((Math.PI / 2) * (played / 0.25));
    }
    if (played > 0.25 && played <= 0.5) {
      played -= 0.25;
      return 92 + 81 * Math.sin((Math.PI / 2) * ((0.25 - played) / 0.25));
    }
    if (played > 0.5 && played <= 0.75) {
      played -= 0.5;
      return 11 + 81 * (1 - Math.cos((Math.PI / 2) * ((0.25 - played) / 0.25)));
    }
    if (played > 0.75 && played <= 1) {
      played -= 0.75;
      return 11 + 81 * (1 - Math.cos((Math.PI / 2) * (played / 0.25)));
    }
    return 0;
  };

  mouseMoveHandler = (event) => {
    if (this.state.isFirstMove) {
      this.setState({isFirstMove: false, coords: {x: event.offsetX, y: event.offsetY}});
      return;
    }
    // +x = +y -x = +y
    this.setState({coords: {x: this.state.coords.x - event.movementY, y: this.state.coords.y + event.movementX}});
    this.setSeek();
  };

  touchMoveHandler = event => {
    let rect = this.circle.current.getBoundingClientRect();
    if (this.state.isFirstMove) {
      this.setState({isFirstMove: false, coords: {x: -(event.targetTouches[0].pageY - rect.bottom), y: -(event.targetTouches[0].pageX - rect.left)}});
      return;
    }
    // +x = +y -x = +y
    this.setState({coords: {x: -(event.targetTouches[0].pageY - rect.bottom), y: event.targetTouches[0].pageX - rect.left}});
    this.setSeek();
  };

  mouseUpHandler = () => {
    document.removeEventListener('mousemove', this.mouseMoveHandler);
    document.removeEventListener('mouseup', this.mouseUpHandler);
    document.removeEventListener('touchmove', this.touchMoveHandler);
    document.removeEventListener('touchend', this.mouseUpHandler);
    this.setState({isFirstMove: true});
  };

  mouseDownHandler = () => {
    this.pause();
    document.addEventListener('mousemove', this.mouseMoveHandler);
    document.addEventListener('mouseup', this.mouseUpHandler);
    document.addEventListener('touchmove', this.touchMoveHandler);
    document.addEventListener('touchend', this.mouseUpHandler);
  };

  setSeek = () => {
    const deltaX = this.state.coords.x - 91;
    const deltaY = this.state.coords.y - 91;
    let hypotenuse = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY,2));
    let quarter;
    let radians;
    if (this.state.coords.x <= 91) {
      if (this.state.coords.y <= 91) {
        quarter = 3;
        let sin = Math.abs(deltaY) / hypotenuse;
        radians = Math.asin(sin);
      }
      if (this.state.coords.y > 91) {
        quarter = 2;
        let cos = Math.abs(deltaX) / hypotenuse;
        radians = Math.acos(cos);
      }
    }
    if (this.state.coords.x > 91) {
      if (this.state.coords.y <= 91) {
        quarter = 4;
        let cos = Math.abs(deltaX) / hypotenuse;
        radians = Math.acos(cos);
      }
      if (this.state.coords.y > 91) {
        quarter = 1;
        let sin = Math.abs(deltaY) / hypotenuse;
        radians = Math.asin(sin);
      }
    }

    radians = quarter % 2 === 0? 0.25 - ((radians / (Math.PI / 2)) * 0.25): (radians / (Math.PI / 2)) * 0.25;
    const percent = radians + (0.25 * (quarter - 1));
    this.player.seek(this.state.playerState.duration * percent);
  };

  convertToMinutes = seconds => {
    let minutesString = Math.floor(seconds / 60);
    let secondsString = Math.floor(seconds % 60);
    return `${minutesString < 10? '0' + minutesString: minutesString}:${secondsString < 10? '0' + secondsString: secondsString}`;
  };

  render () {

    const { classes } = this.props;


    if (this.state.playerState.ended) {
      setTimeout(() => window.location = 'https://try.mindwell.live/payment-stripe', 1000)
    }

    return (
        <div className={classes.meditationContainer}
             style={{background: `no-repeat center / cover url(${Background})`}}>
          <SVG className={classes.meditationLogo} src={Logo} alt="logo"/>
          <div className={classes.meditationInfo}>
            <h3>Getting a Work Life Balance</h3>
            <h6>{this.convertToMinutes(this.state.playerState.duration)}</h6>
          </div>
          <div className={classes.meditationButtonContainer}>
            <svg className={classes.meditationRadialGradient} onMouseDown={this.mouseDownHandler} onTouchStart={this.mouseDownHandler} height="184px"
                 width="184px">
              <radialGradient id="circle-gradient" cx="50%" y="50%" r="100%">
                <stop stopColor="rgba(255, 255, 255, 0)" offset="1.95%"/>
                <stop stopColor="rgba(255, 255, 255, 0.29)" offset="57.76%"/>
                <stop stopColor="rgb(255, 255, 255)" offset="100%"/>
              </radialGradient>
              <circle style={{
                stroke: 'url(#circle-gradient)',
                strokeWidth: '81px',
                strokeDashoffset: 252 - (252 * this.loadPercentage()),
                strokeOpacity: 0.3,
              }} className={classes.meditationLoadingRadialGradient} cx="92px" cy="92px" r="40px" fill="transparent"/>
              <circle
                  ref={this.circle}
                  style={{
                    stroke: '#fff',
                    strokeWidth: '3px',
                    strokeDasharray: 502,
                    strokeDashoffset: 502 - (502 * this.playedPercentage()),
                  }}
                  cx="92px"
                  cy="92px"
                  r="80px"
                  fill="transparent"
              />
              <circle fill="#fff" r="9px" style={{cursor: 'pointer'}} cx={`${this.coordinateX()}px`} cy={`${this.coordinateY()}px`}/>
            </svg>
            <SVG className={classes.meditationButton}
                 style={{left: this.state.playerState.paused? 'calc(50% - 17px)': 'calc(50% - 13px)' }}
                 src={this.state.playerState.paused ? Play : Pause}
                 onClick={this.state.playerState.paused ? this.play : this.pause} alt=""/>
            <h6 className={classes.meditationCurrentTime}>{this.convertToMinutes(this.state.playerState.currentTime)}</h6>
          </div>
          <Player
              ref={(playerRef) => {
                this.player = playerRef;
              }}
              src="https://prod-media.mindwell.live/audio/326.mp3"
              playsInline
              className={classes.customPlayer}
          />
        </div>
    );
  }
}

export default injectSheet(styles)(Meditation);
